import asyncActionTypes from '../types.js';

/**
 * @param {String} tripType - trip type selected
 */
export function changeTripType(tripType) {
  return {
    type: asyncActionTypes.CHANGE_TRIP_TYPE,
    tripType,
  };
}

/**
 * @param {array} airportsList - airports list
 */
export function changeAirportsList(airportsList) {
  return {
    type: asyncActionTypes.CHANGE_AIRPORTS_LIST,
    airportsList,
  };
}

/**
 * @param {Object} originAirport - airport origin
 */
export function changeOriginAirport(originAirport) {
  return {
    type: asyncActionTypes.CHANGE_ORIGIN_AIRPORT,
    originAirport,
  };
}

/**
 * @param {Object} destinationAirport - airport destination
 */
export function changeDestinationAirport(destinationAirport) {
  return {
    type: asyncActionTypes.CHANGE_DESTINATION_AIRPORT,
    destinationAirport,
  };
}

/**
 * @param {array} airportsListFiltered - airports list filtered
 */
export function changeAirportsListFiltered(airportsListFiltered) {
  return {
    type: asyncActionTypes.CHANGE_AIRPORTS_LIST_FILTERED,
    airportsListFiltered,
  };
}

/**
 * @param {Object} passengersData - new passengers data object
 */
export function changePassengerCount(passengersData) {
  return {
    type: asyncActionTypes.CHANGE_PASSENGER_COUNT,
    passengersData,
  };
}

export function setCubaSelected(value) {
  return {
    type: asyncActionTypes.CUBA_SELECTED,
    value,
  };
}